import { ChevronDown } from "lucide-react";
import React, { ReactNode } from "react";

import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  useTheme,
} from "@mui/material";
import Grid from "@mui/material/Grid";
import { MessageFlags } from "@src/features/ai/components/WorkflowEditor/execution/types";

type ReasoningProps = {
  headerComponent: ReactNode;
  bodyComponent: ReactNode;
  isExpandable: boolean;
} & MessageFlags;

export const AiMessageAccordion: React.FC<ReasoningProps> = ({
  headerComponent,
  bodyComponent,
  isExpandable,
}) => {
  const theme = useTheme();

  return (
    <Grid container justifyContent="flex-start">
      <Grid size={12}>
        <Accordion
          expanded={isExpandable ? undefined : false}
          disabled={!isExpandable}
          elevation={0}
          disableGutters
          sx={{
            padding: "0px 10px",
            backgroundColor:
              theme.igBackgroundColors.interactive.neutral.default,
            "&.MuiAccordion-root": { borderRadius: "4px" },
            "&.Mui-disabled": {
              backgroundColor:
                theme.igBackgroundColors.interactive.neutral.default,
            },
            "& .MuiAccordionSummary-root.Mui-disabled": {
              opacity: 1,
              cursor: "default",
            },
          }}
        >
          <AccordionSummary
            expandIcon={isExpandable ? <ChevronDown size={16} /> : null}
            sx={{
              minHeight: "auto",
              "&.MuiAccordionSummary-root": { padding: "0px 0px" },
              "& .MuiAccordionSummary-content": { margin: 0 },
              "& > p": { padding: 0 },
            }}
          >
            {headerComponent}
          </AccordionSummary>
          <AccordionDetails sx={{ padding: "0px 12px 8px 12px" }}>
            {bodyComponent}
          </AccordionDetails>
        </Accordion>
      </Grid>
    </Grid>
  );
};
